import { SGTM_GA_MEASUREMENT_ID } from "../config.ts";
import { consoleDestination, sgtmDestination } from "../destinations";
import { getGAClientId, getGASessionId } from "../ga";
import type {
  AnalyticsDestination,
  AnalyticsEvent,
  AnalyticsEventParams,
  AnalyticsUserContext,
} from "./analytics.types.ts";

let userContext: AnalyticsUserContext = {};
export function updateAnalyticsUserContext(next: AnalyticsUserContext): void {
  userContext = { ...userContext, ...next };
}

const destinations: AnalyticsDestination[] = [
  consoleDestination,
  sgtmDestination,
];

export function track(name: string, params: AnalyticsEventParams = {}): void {
  const event: AnalyticsEvent = {
    cid: getGAClientId(),
    sid: getGASessionId(),
    tid: SGTM_GA_MEASUREMENT_ID,
    user: {
      sha256_email: userContext.sha256Email,
      sha256_phone: userContext.sha256Phone,
      u_id: userContext.userId,
    },
    page: {
      location: window.location.href,
      referrer: document.referrer || undefined,
      title: document.title || undefined,
      language: userContext.language,
    },
    event: {
      ...params,
      name,
      measurement_source: "web",
      timestamp: Date.now(),
    },
  };
  for (const destination of destinations) {
    destination.push(event);
  }
}
